import axios from 'axios'

const API_ENDPOINT = '/person'

export const submitQuestionnaire8im = (token, tab) => {
    return axios.post(`${API_ENDPOINT}/submitQuestionnaire8im`, {token, tab})
  }

  export const submitQuestionnairePref = (token, tab) => {
    return axios.post(`${API_ENDPOINT}/submitQuestionnairePref`, {token, tab})
  }

  export const submitQuestionnaireEtudes = (token, tab) => {
    return axios.post(`${API_ENDPOINT}/submitQuestionnaireEtudes`, {token, tab})
  }

  export const submitQuestionnaireFree = (tab, nom, pre, mail) => {
    return axios.post(`${API_ENDPOINT}/submitQuestionnaireFree`, {tab, nom, pre, mail})
  }

